import { courseUiText } from "../copy.js";
import Icon from "./icon.marko";

<const/uiLang=$global.uiLang || input.copy?.uiLang || 'en'/>

<const/copy=input.copy/>
<header class="ll-course-lesson-bar">
  <div class="ll-course-lesson-bar__mid">
    <div class=["ll-course-steps",input.script&&"ll-script-stages"] data-ll-step-bar>
      <for|step| of=input.steps>
        <const/target=input.targets?.[step] || step/>
        <button type="button" ...(input.script?{'data-script-go':target,...(target!==step?{'data-script-section-pill':step}:{})}:{'data-ll-go':step}) aria-label=input.labels[step] title=input.labels[step]><span class="ll-course-steps__track"><if=target!==step><span class="ll-course-steps__fill"></span></if></span></button>
      </for>
    </div>
    <if=input.finishLabel><span hidden data-script-finish-label>${input.finishLabel}</span></if>
    <span class="ll-course-lesson-bar__label">
      <if=input.sceneNumber>${input.kindLabel || copy.scene} ${input.sceneNumber} · </if><if=input.unitNumber>${courseUiText("Unit {n}", uiLang, {n: input.unitNumber})} · </if><bdi lang=input.lang dir="auto">${input.title}</bdi> · <span class="ll-course-lesson-bar__step" data-ll-step-label>${input.labels[input.steps[0]]}</span>
    </span>
  </div>
  <div class="ll-course-lesson-bar__end">
    <if=input.script && input.alphabet !== false><button type="button" class="ll-course-ghost ll-script-alphabet-button" data-script-alphabet-open><Icon name="file"/> ${courseUiText("Alphabet", uiLang)}</button></if>
    <button type="button" class="ll-course-icon-button" ...(input.script ? { "data-script-restart": "" } : { "data-ll-restart": "" }) aria-label=copy.restart title=copy.restart>
      <Icon name="restart" size=20/>
    </button>
    <a class="ll-course-icon-button" href=input.back aria-label=copy.back title=copy.back>
      <Icon name="close" size=20/>
    </a>
  </div>
</header>
